import { useEffect } from 'react';

export const useDocumentTitleEffect = (title?: string) =>
  useEffect(() => {
    const prevTitle = document.title;
    if (!!title) document.title = title;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
